import { MapTo, withComponentMappingContext } from '@adobe/aem-react-editable-components';
import CobGrid from './CobGrid';

export default MapTo('cob-corp-acquisition/components/creditonebank/cob-grid')(withComponentMappingContext(CobGrid));